import Price from "../appData/price"
import { Product } from "../appData/productData"

export default class PromoPricingInfo {
  static fromYearlyProducts(
    promoProduct: Product,
    yearlyProduct: Product,
    useDiscount: boolean = false,
  ) {
    return new PromoPricingInfo(promoProduct, yearlyProduct, false, useDiscount)
  }

  static fromYearlyAndMonthlyProduct(
    promoProduct: Product,
    monthlyProduct: Product,
    isMonthly: boolean,
    useDiscount: boolean,
  ) {
    return new PromoPricingInfo(
      promoProduct,
      monthlyProduct,
      isMonthly,
      useDiscount,
    )
  }

  private constructor(
    public promoProduct: Product,
    public baseProduct: Product,
    private isMonthly: boolean,
    private useDiscount: boolean,
  ) {}

  get savingPercent() {
    const basePrice = this.yearlyPriceFull.value

    return Math.round((1 - this.yearlyPriceDiscounted.value / basePrice) * 100)
  }

  get monthlyPrice(): Price {
    return new Price(
      this.promoProduct.price / 12,
      this.promoProduct.priceLocale,
    )
  }

  get discountedMonthlyPrice(): Price {
    return new Price(
      this.yearlyPriceDiscounted.value / 12,
      this.promoProduct.priceLocale,
    )
  }

  get yearlyPriceDiscounted(): Price {
    let price = this.promoProduct.introPricing?.price ?? this.promoProduct.price

    if (this.useDiscount && this.promoProduct.discounts.length > 0) {
      price = this.promoProduct.discounts[0].price
    }

    return new Price(price, this.promoProduct.priceLocale)
  }

  get yearlyPriceFull(): Price {
    if (this.useDiscount && !this.isMonthly) {
      return new Price(this.promoProduct.price, this.promoProduct.priceLocale)
    }

    const basePrice = this.isMonthly
      ? this.baseProduct.price * 12
      : this.baseProduct.price

    return new Price(basePrice, this.baseProduct.priceLocale)
  }
}
